import axiosInstance from "@/api/axiosInstance";

export const getKitsPendingTestingApi = () => {
  const response = axiosInstance.get(`/test-kits/?page=1&page_size=5&is_pending_test=true`);
  return response;
};

export const getKitsPendingResultUploadApi = () => {
  const response = axiosInstance.get(`/test-kits/?page=1&page_size=5&is_pending_result_upload=true`);
  return response;
};

export const getHomePageStatsApi = () => {
  const response = axiosInstance.get(`/stats/`);
  return response;
}

export const getKitsPendingSampleCollectionApi = () => {
  const response = axiosInstance.get(`/test-kits/?page=1&page_size=5&is_pending_sample_collection=true`);
  return response;
};
